const changesetFields = [
  'name',
  'phone',
  'taxNumber',
  'salesTaxId',
  'commercialRegister',
  'commercialRegisterId',
  'gln',
  'masterKin',
  'naceCode',
  'industry',
  'organizationType',
  'address_street',
  'address_streetNumber',
  'address_zipCode',
  'address_city',
  'address_countryCode',
  'billingEmail',
  'billingLanguageIsoCode',
  'paymentInformation_iban',
  'paymentInformation_bic',
  'paymentInformation_bank',
  'markantId',
  'crmId',
  'platformRequestStatus',
] as const;
export type OrgChangeSetFields = (typeof changesetFields)[number];

const displayFields: Record<OrgChangeSetFields, string> = {
  name: 'organization.details.fields.name.label',
  phone: 'organization.details.fields.contactPhone.label',
  taxNumber: 'organization.details.fields.taxNumber.label',
  salesTaxId: 'organization.details.fields.salesTaxId.label',
  commercialRegister: 'organization.details.fields.commercialRegister.label',
  commercialRegisterId: 'organization.details.fields.commercialRegisterId.label',
  gln: 'organization.details.fields.gln.label',
  masterKin: 'organization.details.fields.masterKin.label',
  naceCode: 'organization.details.fields.naceCode.label',
  industry: 'organization.details.fields.industry.label',
  organizationType: 'organization.details.fields.organizationType.label',
  address_street: 'organization.details.fields.address.street.label',
  address_streetNumber: 'organization.details.fields.address.streetNumber.label',
  address_zipCode: 'organization.details.fields.address.zipCode.label',
  address_city: 'organization.details.fields.address.city.label',
  address_countryCode: 'organization.details.fields.address.countryCode.label',
  billingEmail: 'organization.details.fields.billingEmail.label',
  billingLanguageIsoCode: 'organization.details.fields.billingLanguageIsoCode.label',
  paymentInformation_iban: 'organization.details.fields.paymentInformation.iban.label',
  paymentInformation_bic: 'organization.details.fields.paymentInformation.bic.label',
  paymentInformation_bank: 'organization.details.fields.paymentInformation.bank.label',
  markantId: 'organization.details.fields.markantId.label',
  crmId: 'organization.details.fields.technical.crmId',
  platformRequestStatus: 'organization.table.filterOptions.orgaStatus',
};

const isoValues: Partial<Record<OrgChangeSetFields, string>> = {
  address_countryCode: 'region',
  billingLanguageIsoCode: 'language',
};

export const OrgTransformerOptions = {
  displayFields,
  isoValues,
};
